import { Box } from '@mui/material'
import Footer from 'src/view/layout/Footer'
import Header from 'src/view/layout/Header'

const styles = {
  root: {
    color: 'inherit',
    fontFamily: `'Roboto', sans-serif`,
    position: 'relative',

    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },

  content: {
    //The content goes under the header because the header is MuiAppBar, which has position:'fixed'.
    //The header has height:'55px' so we need to move the content 55px down to align in below the header and not under it.
    //Add another 10px to a total of 65 fixels there is a 10px margin between the header and the content.

    //We set margins here instead of having a ContentWrapper on every page.
    margin: '10px',
    marginTop: '65px',
    marginBottom: '50px', // We need to add some margin at the bottom so that the content does not go under the footer.
    flex: 1, // This makes the content area grow to fill available space
  },
}

function LayoutPublic(props) {
  return (
    <>
      <Box sx={styles.root}>
        <Header hideMenuIcon />
        <Box sx={styles.content}>{props.children}</Box>
        <Footer />
      </Box>
    </>
  )
}

export default LayoutPublic
